import { imageTypes, videoTypes, audioTypes } from '../shared/constants/fileTypes.js'
export const validarTipoArquivo = (fileExtension, accept) => {
  if (!accept || !fileExtension) return true
  const extension = `.${fileExtension.toLowerCase()}`
  const acceptArray = Array.isArray(accept) 
    ? accept 
    : accept.split(',').map(ext => ext.trim())
  
  return acceptArray.some(acceptedExtension => {
    switch(acceptedExtension) {
      case 'audio/*':
        return audioTypes.includes(extension)
      case 'image/*':
        return imageTypes.includes(extension)
      case 'video/*':
        return videoTypes.includes(extension)
      default:
        return extension === acceptedExtension.toLowerCase()
    }
  })
}
export const tipoArquivoInvalido = (fileExtension, accept) => {
  return !validarTipoArquivo(fileExtension, accept)
}
export const tamanhoArquivoInvalido = (tamanhoBytes, tamanhoMaximoMb) => {
  if (!tamanhoMaximoMb) return false
  return tamanhoBytes > tamanhoMaximoMb * 1024 * 1024
}
export const extrairExtensaoArquivo = (fileName) => {
  if (!fileName || typeof fileName !== 'string') return ''
  return (fileName.split('.').pop() || '').toLowerCase()
}
export const formatarExtensoesParaExibicao = (accept) => {
  if (!accept) return ''
  
  const acceptArray = Array.isArray(accept) 
    ? accept 
    : accept.split(',').map(ext => ext.trim())
  
  return acceptArray.join(', ')
}
export const construirObjetoArquivo = (arquivo, id) => {
  return {
    id: id || Date.now(),
    name: arquivo.name || "",
    size: arquivo.size || 0,
    type: arquivo.type || "",
    fileExtension: extrairExtensaoArquivo(arquivo.name),
    buffer: null,
    isUploaded: false,
    inputFile: arquivo,
    url: "",
  }
}
